module.exports = __webpack_public_path__ + "img/648coupon.dd9dbbbc.png";